import { Controller } from "@hotwired/stimulus"

// Opens/closes the per-section work-time rules edit dialogs (native <dialog>,
// one for break rules, one for duration limits). The open value re-opens a
// section's dialog after a validation-error re-render. resetToInherit clears
// the section's mode select ("Nicht konfiguriert") and submits, so the level
// falls back to the next configured layer.
export default class extends Controller {
  static targets = ["dialog"]
  static values = { open: String }

  connect() {
    if (this.openValue) this.showDialog(this.openValue)
    this.boundBackdropClick = this.backdropClick.bind(this)
    this.dialogTargets.forEach((dialog) =>
      dialog.addEventListener("click", this.boundBackdropClick),
    )
  }

  disconnect() {
    this.dialogTargets.forEach((dialog) =>
      dialog.removeEventListener("click", this.boundBackdropClick),
    )
  }

  open(event) {
    this.showDialog(event.params.name)
  }

  close(event) {
    event.target.closest("dialog")?.close()
  }

  resetToInherit(event) {
    const form = event.target.closest("form")
    const modeSelect = form.querySelector("select[name$='[mode]']")
    if (modeSelect) {
      modeSelect.value = ""
      modeSelect.dispatchEvent(new Event("change"))
    }
    form.requestSubmit()
  }

  showDialog(name) {
    this.dialogTargets.find((dialog) => dialog.dataset.dialogName === name)?.showModal()
  }

  backdropClick(event) {
    if (event.target instanceof HTMLDialogElement) event.target.close()
  }
}
